import { setCookie } from "utils/cookie";
import {
  postApi,
  putWithToken,
  getWithUrl,
  deleteWithToken,
  patchWithToken,
  postFormDataWithToken,
  deleteWithTokenAndData,
} from "../../utils/request";
import { getWithToken, postWithToken } from "../../utils/request";
import toast from "react-hot-toast";

export const LOGIN_Action = "LOGIN_Action";
export const ACCOUNT_LIST = "ACCOUNT_LIST ";
export const COMPLAINT_LIST = "COMPLAINT_LIST ";
export const EXPORT_LIST = "EXPORT_LIST ";
export const ANALYTICS_DATA = "ANALYTICS_DATA ";
export const FREQUENCY_DATA = "FREQUENCY_DATA ";

export const loginAction = (payload) => {
  return async function () {
    toast.loading("Authenticating....");
    try {
      const response = await postApi("/auth/login", payload);

      if (response.status === 200) {
        const result = response.data;
        setCookie("token", `Bearer ${result.access_token}`);
        setCookie("refreshToken", `${result.refresh_token}`);
        setCookie(
          "role",
          result.role === "superadmin" ? "super-admin" : `${result.role}`
        );
        setCookie("phone", `${result.mobile_number}`);
        setCookie("user_name", `${result.firstname} ${result.lastname}`);
        setCookie("email", `${result.email}`);
        setCookie("account_id", `${result.account_id}`);

        toast.dismiss();
        toast.success("You've successfully logged in.🎉");
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Network Error");
      console.log("Login error:", error);
    }
  };
};
export const signUpAction = (payload) => {
  return async function (dispatch) {
    toast.loading("Authenticating....");
    try {
      const response = await postApi("/auth/register", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success(
          "Success! Your account has been created. 🎉 Please log in to continue."
        );
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Signup error:", error);
    }
  };
};
export const logoutAction = () => {
  return async () => {
    toast.loading("Authenticating....");
    try {
      let url = `/auth/logout`;
      const response = await getWithToken(url);
      toast.dismiss();
      toast.success("You’ve successfully logged out. See you soon! 👋");
      return response;
    } catch (error) {
      toast.error(error.message || error.detail[0].msg);
      console.error("API error:", error);
    }
  };
};
export const verifyEmail = (email) => {
  return async () => {
    try {
      let url = `/auth/verify_email?email=${email}`;

      // const queryParams = [];
      // if (email) queryParams.push(`email=${email}`);
      // if (queryParams.length > 0) {
      //   url += `&${queryParams.join("&")}`;
      // }
      const response = await getWithUrl(url);

      return response;
    } catch (error) {
      console.error("API error:", error);
    }
  };
};
export const forgotPassword = (payload) => {
  return async () => {
    try {
      const response = await postApi("/auth/forgot_password", payload);
      if (response?.status === 200) {
        toast.success(
          "Password reset instructions have been sent to your email. Please check your mail inbox (and spam folder) and follow the steps to reset your password. If you don't see the email shortly, try requesting a reset again."
        );
      } else {
        toast.error(
          "We encountered an issue processing your password reset request. Please try again later. If the problem persists, contact support for assistance."
        );
      }
      return response;
    } catch (error) {
      console.error("API error:", error);
      toast.error(
        "We encountered an issue processing your password reset request. Please try again later. If the problem persists, contact support for assistance."
      );
    }
  };
};
export const getAllAccounts = ({
  search,
  role,
  startDate,
  endDate,
  status,
  sort,
  skip,
  limit,
}) => {
  return async (dispatch) => {
    try {
      let url = `/auth/list?skip=${skip || 0}&limit=${limit || 10}`; // Corrected base URL

      const queryParams = [];
      if (search) queryParams.push(`search=${search}`);

      if (startDate) {
        queryParams.push(`start_ts=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`end_ts=${endDate}`);
      }
      if (sort) {
        queryParams.push(`sort=${sort}`);
      }
      if (status === 0 || status === 1 || status === 2) {
        queryParams.push(`status=${status}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      const response = await getWithToken(url);

      if (response) {
        const accounts = response.data.data;

        dispatch({
          type: ACCOUNT_LIST,
          payload: accounts || [],
          totalCount: response.data.count,
          skip: skip,
          limit: limit,
        });

        return response;
      }
    } catch (error) {
      dispatch({
        type: ACCOUNT_LIST,
        payload: [],
      });
      toast.error(error.message || error.detail[0].msg);
      console.error("Get Accounts error:", error);
    }
  };
};
export const postCreateAccount = (payload) => {
  return async function () {
    toast.loading("Adding new account....");
    try {
      const response = await postWithToken("/auth/register", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success("New account has been created.");
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Account Creation error:", error);
    }
  };
};
export const postEditAccount = (payload) => {
  return async function () {
    toast.loading("Editing new account....");
    try {
      const response = await putWithToken("/auth/update", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success("Account has been updated.");
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Account Editing error:", error);
    }
  };
};
export const deleteAccount = ({ id: id }) => {
  return async (dispatch) => {
    toast.loading("deleting...");
    try {
      const response = await deleteWithToken(`/auth/delete?account_id=${id}`);
      toast.dismiss();

      return response;
    } catch (error) {
      console.error("Deleting Account Err:", error);
      toast.dismiss();
      toast.error(error?.message);
      throw error;
    }
  };
};
export const getAllComplaints = ({
  search,
  startDate,
  endDate,
  sort,
  complaintType,
  complaintStatus,
  skip,
  limit,
}) => {
  return async (dispatch) => {
    try {
      let url = `/complaint/list?skip=${skip || 0}&limit=${limit || 10}`; // Corrected base URL

      const queryParams = [];
      if (search) queryParams.push(`search=${search}`);

      if (
        complaintStatus === 0 ||
        complaintStatus === 1 ||
        complaintStatus === 2 ||
        complaintStatus === 3
      ) {
        queryParams.push(`status=${complaintStatus}`);
      }
      if (complaintType) {
        queryParams.push(`complaint_type=${encodeURIComponent(complaintType)}`);
      }
      if (sort) {
        queryParams.push(`sort=${sort}`);
      }
      if (startDate) {
        queryParams.push(`start_ts=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`end_ts=${endDate}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      const response = await getWithToken(url);

      if (response) {
        const complaints = response.data.data;

        dispatch({
          type: COMPLAINT_LIST,
          payload: complaints || [],
          totalCount: response.data.count,
          skip: skip,
          limit: limit,
        });

        return response;
      }
    } catch (error) {
      dispatch({
        type: COMPLAINT_LIST,
        payload: [],
      });
      toast.error(
        error?.message || error?.detail[0]?.msg || error?.message[0]?.msg
      );
      console.error("Get Complaints error:", error);
    }
  };
};
export const exportAllComplaints = ({
  search,
  role,
  startDate,
  endDate,
  skip,
  limit,
}) => {
  return async (dispatch) => {
    try {
      let url = `/complaint/list`; // Corrected base URL

      const queryParams = [];
      if (search) queryParams.push(`search=${search}`);

      if (startDate) {
        queryParams.push(`start_ts=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`end_ts=${endDate}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      const response = await getWithToken(url);

      if (response) {
        const complaints = response.data.data;

        dispatch({
          type: EXPORT_LIST,
          payload: complaints || [],
          totalCount: response.data.count,
          skip: skip,
          limit: limit,
        });

        return response;
      }
    } catch (error) {
      dispatch({
        type: EXPORT_LIST,
        payload: [],
      });
      toast.error(error.message || error.detail[0].msg);
      console.error("Export get Complaints error:", error);
    }
  };
};
export const postRaiseComplaint = (payload) => {
  return async function () {
    toast.loading("Submitting new complaint....");
    try {
      const response = await postWithToken("/complaint", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success("New complaint has been submitted.");
      }
      return "response";
    } catch (error) {
      toast.dismiss();

      if (error.status === 422) {
        toast.error("Invalid values submitted");
        console.log("Complaint Lodging error:", error);
      } else {
        toast.error(error.message);
      }
    }
  };
};
export const postUploadImages = (fileData) => {
  return async function (dispatch) {
    try {
      var formData = new FormData();
      const imageFiles = fileData.files;

      // Append all images to FormData
      imageFiles.forEach((imageFile, index) => {
        formData.append("files", imageFile); // Use "files[]" to send multiple files
      });

      const response = await postFormDataWithToken(
        "/complaint/upload",
        formData
      );

      if (response.status === 200) {
        toast.success("Images uploaded successfully!");
      } else {
        toast.error("Failed to upload images.");
      }

      return response;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Image upload error:", error);
    }
  };
};
export const deleteComplaint = ({ id: id }) => {
  return async () => {
    toast.loading("deleting...");
    try {
      const response = await deleteWithTokenAndData(`/complaint/delete`, {
        complaint_ids: [id],
      });
      toast.dismiss();
      return response;
    } catch (error) {
      console.error("Deleting Complaint Err:", error);
      toast.dismiss();
      toast.error(error?.message);
      throw error;
    }
  };
};
export const editRaisedComplaint = (payload) => {
  return async function () {
    toast.loading("Updating complaint....");
    try {
      const response = await putWithToken("/complaint/update", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success("Complaint status has been updated.");
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Complaint Editing error:", error);
    }
  };
};
export const getAllAnalytics = ({ startDate, endDate }) => {
  return async (dispatch) => {
    try {
      let url = `/analytics/stat`; // Corrected base URL

      const queryParams = [];
      // if (search) queryParams.push(`search=${search}`);

      if (startDate) {
        queryParams.push(`start_ts=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`end_ts=${endDate}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      const response = await getWithToken(url);

      if (response) {
        const analytics = response.data.data;

        dispatch({
          type: ANALYTICS_DATA,
          payload: analytics || [],
          totalCount: response.data.count,
        });

        return response;
      }
    } catch (error) {
      dispatch({
        type: ANALYTICS_DATA,
        payload: [],
      });
      toast.error(error.message || error.detail[0].msg);
      console.error("Get Analytics error:", error);
    }
  };
};
export const getFrequencyData = ({ startDate, endDate }) => {
  return async (dispatch) => {
    try {
      let url = `/analytics/complaint/freq`; // Corrected base URL

      const queryParams = [];
      // if (search) queryParams.push(`search=${search}`);

      if (startDate) {
        queryParams.push(`start_ts=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`end_ts=${endDate}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      const response = await getWithToken(url);

      if (response) {
        const analytics = response.data.data;

        dispatch({
          type: FREQUENCY_DATA,
          payload: analytics || [],
          totalCount: response.data.count,
        });

        return response;
      }
    } catch (error) {
      dispatch({
        type: FREQUENCY_DATA,
        payload: [],
      });
      toast.error(error.message || error.detail[0].msg);
      console.error("Get Frequency error:", error);
    }
  };
};
export const patchChangePassword = (payload) => {
  return async function () {
    toast.loading("Changing password....");
    try {
      const response = await patchWithToken("/auth/change/password", payload);

      if (response.status === 200) {
        toast.dismiss();
        toast.success("Password changed successfully.Please Sign in again..");
        localStorage.clear();
      }
      return "response";
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      console.log("Changing Password error:", error);
    }
  };
};
export const resetPassword = (payload) => {
  console.log("payload", payload);
  // Check if the token exists before making the request
  if (!payload?.onPageToken) {
    console.error("No token found in the payload.");
    toast.error("Invalid request. No token found.");
    return;
  }

  // Return and execute the async function
  return async () => {
    try {
      const response = await postApi(
        "/auth/reset_password",
        {
          password: payload?.password,
          confirm_password: payload?.confirm_password,
        },
        {
          Authorization: `Bearer ${payload?.onPageToken}`,
        }
      );

      if (response?.status === 200) {
        toast.success("Password has been reset. Please sign in.");
      } else {
        toast.error(
          "We encountered an issue processing your password reset request. Please try again later. If the problem persists, contact support for assistance."
        );
      }
      return response;
    } catch (error) {
      console.error("API error:", error);
      toast.error(
        "We encountered an issue processing your password reset request. Please try again later. If the problem persists, contact support for assistance."
      );
    }
  };
};
